import { createModule } from 'terrific-singleton';
import { TerrificSpec } from 'terrific-singleton/terrific-module';
import { triggerPublicEvent, PublicEvents } from '@project/shared/utils/events/js/events';

const classes = {
	stateActive: 'state-m-teaser-benefit--active',
	ongoingTransition: 'state-m-teaser-benefit--ongoing-transition',
};

@createModule('TeaserBenefit')
/**
 * teaser-benefit module implementation.
 *
 * @author Heiko Frosch <heiko.frosch@namics.com>
 */
export class TeaserBenefit extends TerrificSpec {
	$ctx: JQuery;
	/**
	 * start method, called on terrific bootstap
	 *
	 * @param {Object} resolve  function to call at the end of component start
	 * @returns {void}
	 */
	start(resolve: () => void) {
		this.$ctx = $(this._ctx);

		$(this.$ctx).on('click', (event: Event) => {
			this._triggerAccordion(event);
		});

		resolve();
	}
	/**
	 * stop method, called on terrific stop
	 *
	 * @returns {void}
	 */
	stop() {}

	_triggerAccordion(event: Event) {
		const $currentTarget = $(event.currentTarget);
		$currentTarget.toggleClass(classes.stateActive);

		if ($currentTarget.hasClass(classes.ongoingTransition)) {
			setTimeout(function() {
				$currentTarget.removeClass(classes.ongoingTransition);
			}, 620);
		} else {
			$currentTarget.addClass(classes.ongoingTransition);
		}
	}
}
